import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
@Component({
  selector: "app-equilibrium-life",
  templateUrl: "./equilibrium-life.component.html",
  styleUrls: ["./equilibrium-life.component.css"],
})
export class EquilibriumLifeComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }
}
